import React from "react";
import { Loader2, Shield } from "lucide-react";
import { formatFixtureDate, formatFixtureTime } from "../../../utils/formatFixtureDate";
import { isFixtureLive } from "../../../utils/p2pCreateHelpers";

const TeamSide = ({ team, align }) => (
  <div className={`pcr-side pcr-side-${align}`}>
    <div className="pcr-crest">
      {team?.logo ? (
        <img src={team.logo} alt="" />
      ) : (
        <Shield size={18} aria-hidden />
      )}
    </div>
    <span className="pcr-team-name" title={team?.name || ""}>
      {team?.name || (align === "home" ? "Home" : "Away")}
    </span>
  </div>
);

const MatchRow = ({
  row,
  hideLeague = false,
  onChallenge,
  ctaLabel = "Challenge",
  busy = false,
  disabled = false,
}) => {
  const { fixture, league } = row;
  const live = isFixtureLive(fixture);

  const handleClick = () => {
    if (disabled || busy) return;
    onChallenge?.({ fixture, league });
  };

  return (
    <button
      type="button"
      className={`pcr-row${busy ? " pcr-row-busy" : ""}${disabled ? " pcr-row-disabled" : ""}`}
      onClick={handleClick}
      disabled={disabled || busy}
    >
      <TeamSide team={fixture?.homeTeam} align="home" />

      <div className="pcr-centre">
        <span className={`pcr-time ${live ? "pcr-time-live" : ""}`}>
          {live ? "LIVE" : formatFixtureTime(fixture?.date)}
        </span>
        {hideLeague ? (
          <span className="pcr-date">{formatFixtureDate(fixture?.date)}</span>
        ) : (
          <span className="pcr-league" title={league?.name}>
            {league?.logo ? <img src={league.logo} alt="" /> : null}
            <span>{league?.name}</span>
          </span>
        )}
      </div>

      <TeamSide team={fixture?.awayTeam} align="away" />

      <span className="pcr-cta" aria-hidden>
        {busy ? <Loader2 size={14} className="pcr-spin" /> : ctaLabel}
      </span>
    </button>
  );
};

export default MatchRow;
